<template>
  <div id="nav">
    <div class="menu toCapitalize">
      <router-link to="/page" data-nav="page"><span>{{locale.nav_page}}</span></router-link>
      <router-link to="/product" data-nav="product"><span>{{locale.product}}</span></router-link>
      <router-link to="/shop" data-nav="shop"><span>{{locale.shop}}</span></router-link>
      <router-link to="/amenity" data-nav="amenity"><span>{{locale.amenity}}</span></router-link>
      <router-link to="/reservation" data-nav="reservation"><span>{{locale.reservation}}</span></router-link>
      <router-link to="/menu" data-nav="menu"><span>{{locale.nav_menu}}</span></router-link>
      <router-link to="/floating" data-nav="floating"><span>{{locale.floating}}</span></router-link>
      <router-link to="/category" data-nav="category"><span>{{locale.nav_category}}</span></router-link>
      <router-link to="/control" data-nav="control"><span>{{locale.roomcontrol}}</span></router-link>
      <router-link to="/tv" data-nav="tv"><span>{{locale.tv_channel_guide}}</span></router-link>
      <router-link to="/localinfo" v-if="partner === 'NSJ' && (userRole === 'admin' || userRole === 'manager')" data-nav="localinfo"><span>{{locale.localinfo}}</span></router-link>
      <!-- <router-link to="/flightinfo" v-if="sitePlan === 'premium' && (userRole === 'admin' || userRole === 'manager')" data-nav="flightinfo"><span class="beta">{{locale.nav_flightinfo}}</span></router-link> -->
      <router-link to="/waitingcall" data-nav="waitingcall"><span>{{locale.waitingcall}}</span></router-link>
      <router-link to="/collection" data-nav="page"><span>{{locale.collection}}</span></router-link>
      <router-link to="/package" data-nav="package"><span>{{locale.package}}</span></router-link>
      <router-link to="/layerpopup" data-nav="layerpopup"><span>{{locale.layerpopup}}</span></router-link>
      <router-link to="/talk/card" data-nav="talk" :class="{'router-link-active': $route.name === 'talk'}"><span>{{locale.staytalk}}</span></router-link>
      <router-link to="/smartvoice" data-nav="smartvoice"><span>{{locale.smartvoice}}</span></router-link>
      <router-link to="/features" data-nav="features"><span>{{locale.more_features}}</span></router-link>
      <router-link to="/thirdparty" data-nav="thirdparty"><span>{{locale.thirdparty}}</span></router-link>
      <router-link to="/coupon" v-if="userRole === 'admin' || userRole === 'manager'" data-nav="coupon"><span>{{locale.nav_coupon}}</span></router-link>
      <router-link to="/analytics" data-nav="analytics"><span>{{locale.analytics}}</span></router-link>
      <router-link to="/setting" v-if="userRole === 'admin'" data-nav="setting"><span>{{locale.nav_setting}}</span></router-link>
      <router-link :to="{name: 'admin', params: {admin: 'userlist'}}" v-if="userRole === 'admin'" data-nav="admin"><span>{{locale.nav_admin}}</span></router-link>
    </div>
    <div :class="{setLocale: true, selectLocale: selectLocale}">
      <button type="button" class="btnLocale" @click.stop="triggerLocale"><img src="~@/assets/img/nav_locale.png" alt="" /></button>
      <div class="localeBox">
        <select v-model="setLocale" class="input toCapitalize">
          <option v-for="locale in localeList" :key="locale" :value="locale">{{getLocaleName(locale)}}</option>
        </select>
      </div>
    </div>
    <div class="serviceInfo">
      <span class="version">{{`v.${service.version}_${service.updated}`}}</span>
      <span class="copyright">{{`&copy; ${company}.`}}</span>
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'

export default {
  name: 'Nav',
  props: [
    'locale'
  ],
  computed: {
    service () {
      return {
        version: this.$store.state.service.version,
        updated: this.$store.state.service.updated
      }
    },
    partner () {
      return this.$store.state.service.partner
    },
    company () {
      let company = "t'order stay"
      if (this.partner === 'NSJ') {
        company = 'CoreGuide'
      }
      return company
    },
    localeList () {
      return this.$store.state.service.locale.list
    },
    userRole () {
      const info = this.$store.getters['authentication/getAuthInfo']
      return info.userRole
    },
    sitePlan () {
      return this.$store.state.authentication.sitePlan
    },
    setLocale: {
      get () {
        return this.$store.state.service.locale.default
      },
      set (val) {
        this.$store.commit('service/setLocale', val)
      }
    }
  },
  mounted () {
    const localLang = localStorage.getItem('lang')
    if (localLang) {
      this.$store.commit('service/setLocale', localLang)
    }
  },
  data () {
    return {
      selectLocale: false
    }
  },
  methods: {
    triggerLocale () {
      this.selectLocale = !this.selectLocale
    },
    getLocaleName (locale) {
      return LANG.list.find(x => x.c === locale).n
    }
  }
}
</script>

<style lang="scss" scoped>
#nav {
  position: relative;
  height: 100%;
}
.btnEditMode {
  position: absolute;
  top: 0;
  left: 100%;
  height: 100px;
}
.btnLocale {
  display: none;
  img {
    width: 32px;
  }
}
.setLocale {
  position: relative;
  padding: 15px 15px 0;
}
.menu {
  min-height: calc(100% - 85px);
  padding-top: 110px;
  background: url('~@/assets/img/logo_edit.png') 50% 40px / 170px auto no-repeat;
}
a {
  display: block;
  position: relative;
  padding: 1.1em 1em 1.1em 2.4em;
  font-size: 1.1em;
  font-weight: 400;
  border-top: 1px solid rgba(255,255,255,0.1);
  border-bottom: 1px solid rgba(0,0,0,0.4);
  transition: all 0.3s;
  .beta {
    position: relative;
    &:after {
      content: "BETA";
      position: absolute;
      top: 0;
      left: 100%;
      margin-top: -0.5em;
      margin-left: 0.5em;
      padding: 0 4px;
      font-size: 0.5em;
      white-space: nowrap;
      color: $color-white;
      border-radius: 2px;
      background-color: $color-blue;
      opacity: 0.75;
    }
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
  }
  &:hover:before {
    background-color: $color-lgrey;
  }
}
.router-link-active {
  color: $color-white;
  background-color: rgba(0,0,0,0.3);
  &:before,
  &:hover:before {
    background-color: $color-primary;
  }
  &:after {
    opacity: 1;
  }
}
.editMode {
  .menu {
    min-height: calc(100% - 60px);
    padding-top: 0;
    background-image: none;
  }
  a {
    padding: 20px 4px;
    font-size: 12px;
    color: $color-dark;
    border-left: 2px solid rgba($color-lgrey, 0.5);
    background-position: 50% 50%;
    .beta {
      &:after {
        content: "(BETA)";
        position: static;
        margin: 0 0 0 0.3em;
        padding: 0;
        color: inherit;
        border-radius: 0;
        background: none;
        opacity: 1;
      }
    }
    &:before {
      display: none;
    }
    &:hover {
      border-left-color: $color-lgrey;
      span {
        opacity: 0.75;
      }
    }
    &.router-link-active {
      border-left-color: $color-primary;
      span {
        opacity: 1;
      }
    }
    span {
      display: block;
      text-align: center;
      line-height: 1.2;
      color: $color-white;
      opacity: 0.5;
    }
  }
  .setLocale {
    height: 60px;
    padding: 0;
    .btnLocale {
      display: initial;
      position: relative;
      width: 100%;
      height: 100%;
      text-align: center;
      background-color: $color-dark;
      z-index: 1;
      img {
        width: 32px;
      }
    }
    .localeBox {
      position: fixed;
      bottom: 0;
      left: -180px;
      width: 180px;
      padding: 10px;
      background-color: $color-dark;
      transition: all 0.3s;
      z-index: 1;
    }
    &.selectLocale {
      .localeBox {
        left: 70px;
      }
    }
  }
  .serviceInfo {
    display: none;
  }
}
.serviceInfo {
  display: flex;
  padding: 8px 15px 60px;
  font-size: 10px;
  opacity: 0.6;
  .copyright {
    margin-left: auto;
  }
}
</style>
